import ApiService from '../../../../shared/services/api-service';
import commonActions from '../../../../shared/store/common/action-creators';
import notificationsActions from '../../notifications/action-creators';
import usersActions from './users';

const userRolesActions = {
  attachUserRole(userGuid, roleGuid, trainingProgramGuid) {
    const post = { roleGuid };
    if (trainingProgramGuid) {
      post.trainingProgramGuid = trainingProgramGuid;
    }

    return async (dispatch) => {
      dispatch(this.setIsLoading('attachUserRole'));
      const data = await ApiService.post(
        `/api/v1/users/${userGuid}/roles`,
        post,
      )
        .then(response => response.data)
        .catch(error => ({ error }));
      dispatch(this.setIsLoading('attachUserRole'));
      if (data.error) {
        dispatch(commonActions.handleApiError(data.error));
      } else {
        dispatch(this.attachUserRoleSuccess(data));
      }
    };
  },
  attachUserRoleSuccess(attachUserRoleResponse) {
    return (dispatch) => {
      dispatch(usersActions.replaceUser(attachUserRoleResponse.data));
      dispatch(notificationsActions.addSavedSuccessfully('Role added'));
      dispatch(usersActions.closeEditUserRoles());
    };
  },
  detachUserRole(userGuid, roleGuid) {
    return async (dispatch) => {
      dispatch(this.setIsLoading('detachUserRole'));
      const data = await ApiService.delete(`/api/v1/users/${userGuid}/roles/${roleGuid}`)
        .then(response => response.data)
        .catch(error => ({ error }));
      dispatch(this.setIsLoading('detachUserRole'));
      if (data.error) {
        dispatch(commonActions.handleApiError(data.error));
      } else {
        dispatch(this.detachUserRoleSuccess(data));
      }
    };
  },
  detachUserRoleSuccess(detachUserRoleResponse) {
    return (dispatch) => {
      dispatch(usersActions.replaceUser(detachUserRoleResponse.data));
      dispatch(notificationsActions.addSavedSuccessfully('Role removed'));
      dispatch(usersActions.closeEditUserRoles());
    };
  },
  updateUserRole(userGuid, roleGuid) {
    return async (dispatch) => {
      dispatch(this.setIsLoading('updateUserRole'));
      const data = await ApiService.patch(
        `/api/v1/users/${userGuid}/roles/${roleGuid}`,
        {},
      )
        .then(response => response.data)
        .catch(error => ({ error }));
      dispatch(this.setIsLoading('updateUserRole'));
      if (data.error) {
        dispatch(commonActions.handleApiError(data.error));
      } else {
        dispatch(this.updateUserRoleSuccess(data));
      }
    };
  },
  updateUserRoleSuccess(updateUserRoleResponse) {
    return (dispatch) => {
      dispatch(usersActions.replaceUser(updateUserRoleResponse.data));
      dispatch(notificationsActions.addSavedSuccessfully('Role updated'));
    };
  },
};

export default userRolesActions;
